// Copyright (c) Docugami, Inc. All rights reserved.

import { useRef, useEffect } from "react";

export enum ExternalClickType {
    Self,
    Children
}

export function useExternalClickHandler<T extends HTMLElement>(type: ExternalClickType, onClickOutside: () => void, disabled?: boolean) {
    const ref = useRef<T>(null);

    useEffect(() => {
        if (!!disabled) {
            return document.removeEventListener('click', handleClickEvent);
        }

        function handleClickEvent(ev: any) {
            if (!ref.current) {
                return;
            }

            if (type === ExternalClickType.Children) {
                if (!!Object.values(ref.current.children).find(child => child.contains(ev.target))) {
                    return;
                }
            } else if (type === ExternalClickType.Self) {
                if (ref.current.contains(ev.target)) {
                    return;
                }
            }

            onClickOutside();
        }

        document.addEventListener('click', handleClickEvent);
        return () => document.removeEventListener('click', handleClickEvent);
    }, [type, onClickOutside, disabled])

    return ref;
}